import { useState } from 'react';

import { useUser } from '../../context/UserProvider';
import { useCommentsDispatch } from '../../context/CommentsProvider';
import { useSettings, useSettingsDispatch } from '../../context/SettingsProvider';

function CommentEditor({btnText, parentId}){

	const userContext = useUser();
	const settings = useSettings();

	const settingsDispatch = useSettingsDispatch();
	const commentsDispatch = useCommentsDispatch();

	const [comment, setComment] = useState('');
	const [error, setError] = useState('');
	const [preview, setPreview] = useState(false);

	const commentsAllowed = settings.isCommentsOpen && (!settings.commentRegistration || userContext.type === "logged");

	const onAddCommentClick = (e) => {

		e.preventDefault();
		setError('');

		if(!comment.trim()){
			setError('Invalid comment string length');
			return;
		}

		if(!userContext.name) {
			const payload = {
				deferedComment: {
					content: comment, 
					parentId: parentId, 
					errorHandler: setError, 
					setComment: setComment
				},
				isFormExpanded: true,
			}
			settingsDispatch({type: 'resolveUser', payload: payload});
			return;
		}

		commentsDispatch({type: 'add', content: comment, parentId: parentId, errorHandler: setError, setComment: setComment});
	}

	return (

		commentsAllowed && 
		<div className={settings.isLoading ? 'comment-editor--wrapper is-loading' : 'comment-editor--wrapper'}>
			{!!error &&
				<div className="comment-editor--error error-message">{error}</div>
			}
			<div className="comment-editor--container">
				{!preview &&
					<textarea
						className={settings.isLoading ? "comment-editor--textarea loading-animation" : "comment-editor--textarea"}
						value={comment}
						onChange={(e) => {setComment(e.target.value)}}
						disabled={settings.isLoading ? true : false}
					></textarea>
				}
				<div className="comment-editor--footer">
					{!!comment && 
						<button
							className='comment-editor--preview-btn'
							onClick={() => {setPreview(!preview)}}
							disabled={settings.isLoading ? true : false}
						>
							{preview ? 'Edit' : 'Preview'}
						</button>
					}
					<button 
						className={settings.isLoading ? "comments--btn loading-animation" : "comments--btn"}
						onClick={onAddCommentClick}
						disabled={settings.isLoading ? true : false}
					>
						{btnText}
					</button>
				</div>
			</div>
			{preview &&
				<div className='comment comment-editor--preview'>
					<div className='comment--header'>
						<span className='comment--user-info'>
							{userContext.name ? userContext.name : 'Not Logged In'}
						</span>
					</div>
					<div className='comment--body'>
						{comment}
					</div>
				</div>
			}
		</div>
	)
}

export default CommentEditor;